import { createColumnHelper } from "@tanstack/react-table";

import type { Course } from "@/types";
import { Badge } from "@/ui/Badge";

const columnHelper = createColumnHelper<Course>();

export function getCoursesTableColumns() {
  const columns = [
    columnHelper.accessor("name", {
      header: "Course Name",
      cell: (info) => (
        <span title={info.getValue()} className="block max-w-64 truncate">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("partner.name", {
      header: "Partner",
      cell: (info) => <span>{info.getValue()}</span>,
    }),
    columnHelper.display({
      id: "materialCount",
      header: "Materials",
      cell: (info) => {
        const materials = info.row.original.materials || [];
        return <span>{materials.length}</span>;
      },
    }),
    columnHelper.display({
      id: "published",
      header: "Status",
      cell: (info) => {
        const published = info.row.original.published;
        return (
          <Badge
            text={published ? "Published" : "Unpublished"}
            className={
              published
                ? "bg-primary-800 text-primary-50"
                : "bg-neutral-300 text-neutral-950"
            }
          />
        );
      },
    }),
  ];

  return columns;
}
